package br.com.texeratx.boardgametimeapp.ui.screens.games.model

data class GameModeUI(
    val id: Long,
    val name: String
)

